import { post } from '@/utils/request'

/**
 * 设置多麦美团外卖信息（专用设置美团）
 * @param {object} data 请求参数
 * @param {string} data.duomai_site_id 多麦推广位ID
 * @param {string} data.duomai_plan_id 多麦美团推广计划ID
 */
export default function taoke_duomai_meituan_set(data) {
  return post('taoke_duomai_meituan_set', data)
}